import React, {useEffect} from 'react';
import {Button, Container, Image, Tab, TabList, TabPanel, TabPanels, Tabs} from "@chakra-ui/react";
import {Flex, Text} from "@chakra-ui/layout";
import Profile from "../../../images/header/profile.svg";
import {useSelector} from "react-redux";
import {StateType, useStudentAuthDispatch} from "../../../store/store";
import {adminLogout, getAccounts} from "../../../action/adminAction";

function AdminCenter() {
  const dispatch = useStudentAuthDispatch();
  const {data: {token}, accounts: {accounts}} = useSelector((state: StateType) => state.rootReducer.adminReducer);
  const adminToken = token.slice(17, (token.length - 2));
  console.log(accounts)

  useEffect(() => {
    dispatch(getAccounts(adminToken))
  }, [])

  function signOut(e: React.MouseEvent<HTMLButtonElement, MouseEvent>) {
    e.preventDefault();
    console.log('sign out button clicked');
    dispatch(adminLogout());
    localStorage.removeItem("vidcom");
  }

  return (
    <Container maxW="container.lg" mt={7}>
      <Tabs variant="unstyled">
        <TabList>
          <Tab bgColor={"brand.white"} color={"brand.gold"} borderRadius={"30px"}
               _selected={{color: "white", bg: "brand.gold"}} mr={7}>Teachers</Tab>
          <Tab bgColor={"brand.white"} color={"brand.gold"} borderRadius={"30px"}
               _selected={{color: "white", bg: "brand.gold"}}>Students</Tab>
        </TabList>
        <TabPanels bgColor={"brand.white"} boxShadow="2xl" borderRadius={"20px"} mt={8}>
          <TabPanel display={"flex"} flexWrap={"wrap"} p={5}>
            {accounts.teachers.map((teacher: any, index: number) => (
                <Flex key={index} flexDirection={"column"} bgColor={"brand.orange"} borderRadius={"20px"} m={2} p={3} w={"300px"}>
                  <Image
                    boxSize="80px"
                    objectFit="cover"
                    mb={3}
                    src={Profile}
                    alt="profile icon"
                    textAlign={"left"}
                  />
                  <Text textTransform={"capitalize"} fontWeight={"semibold"}
                        fontSize={"lg"}>{teacher.teacher_username}</Text>
                  <Text color={"rgba(17, 24, 39, 0.5)"} fontWeight={"medium"}
                        fontSize={"sm"}>{teacher.teacher_email}</Text>
                  {teacher.isverified ? (
                    <Flex mt={5} justifyContent={"flex-end"}>
                      <Button w={"100px"} fontSize={"xs"} fontWeight={"semibold"} textTransform={"capitalize"}
                              borderRadius={"full"} bgColor={"brand.ink"} color={"white"}>
                        terminate
                      </Button>
                    </Flex>
                  ) : (
                    <Flex mt={5} justifyContent={"space-between"}>
                      <Button w={"100px"} fontSize={"xs"} fontWeight={"semibold"} textTransform={"capitalize"}
                              borderRadius={"full"} bgColor={"brand.darkGreen"} color={"white"}>
                        accept
                      </Button>
                      <Button w={"100px"} fontSize={"xs"} fontWeight={"semibold"} textTransform={"capitalize"}
                              borderRadius={"full"} bgColor={"brand.ink"} color={"white"}>
                        reject
                      </Button>
                    </Flex>
                  )}
                </Flex>
              )
            )}
          </TabPanel>
          <TabPanel display={"flex"} flexWrap={"wrap"} p={5}>
            {accounts.students.map((student: any, index) => (
              <Flex key={index} flexDirection={"column"} bgColor={"brand.lightGreen"} borderRadius={"20px"} m={2} p={3}
                    w={"300px"}>
                <Image
                  boxSize="80px"
                  objectFit="cover"
                  src={Profile}
                  alt="profile icon"
                  textAlign={"left"}
                  mb={3}
                />
                <Text textTransform={"capitalize"} fontWeight={"semibold"}
                      fontSize={"lg"}>{student.student_username}</Text>
                <Text color={"rgba(17, 24, 39, 0.5)"} fontWeight={"medium"}
                      fontSize={"sm"}>{student.student_email}</Text>
              </Flex>
            ))}
          </TabPanel>
        </TabPanels>
      </Tabs>
      
      <Button
      textTransform="capitalize"
      p={{base: "25px 50px", lg: "25px 70px"}}
      bgColor="#FEF2F2"
      color="#EF4444"
      borderRadius="20px"
      mt="10"
      onClick={(e) => signOut(e)}
      >sign out</Button>
    </Container>

  );
}

export default AdminCenter;